import React from 'react';

import {AxisDropdown} from '../common/AxisDropdown';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';
import {updateAxisConfig} from './util';

export const YAxis = () => {
  const {config, updateConfig} = useMediaSettingsDrawerContext();
  return (
    <AxisDropdown
      configField="gridSettings"
      initialValue={config.gridSettings.yAxis}
      onSelectOption={option =>
        updateAxisConfig(option, config, updateConfig, 'yAxis')
      }
      title="Y-Axis"
    />
  );
};
